import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7b07b25c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text-truncate" }
const _hoisted_2 = {
  key: 0,
  class: "text-truncate"
}
const _hoisted_3 = {
  key: 0,
  class: "text-truncate"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "las la-pencil-ruler fs-3" }, null, -1))
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "las la-pencil-ruler fs-3" }, null, -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["title", "disabled", "onClick"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye" }, null, -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-edit" }, null, -1))
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-trash-alt" }, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = { class: "word-wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Datatable = _resolveComponent("Datatable")!
  const _component_VZSideDrawer = _resolveComponent("VZSideDrawer")!
  const _component_TemplatePreviewModal = _resolveComponent("TemplatePreviewModal")!
  const _component_VZDeleteModal = _resolveComponent("VZDeleteModal")!
  const _component_VZModal = _resolveComponent("VZModal")!
  const _component_ActivityModal = _resolveComponent("ActivityModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Datatable, {
      "table-data": _ctx.tableData,
      "table-header": _ctx.tableHeader,
      total: _ctx.total,
      rowsPerPage: _ctx.rowsPerPage,
      page: _ctx.page,
      loading: _ctx.loading,
      showSearch: _ctx.showSearch,
      activityTab: false,
      defaultFilter: _ctx.defaultFilter,
      tableFilter: _ctx.tableFilter,
      bulkDelete: _ctx.bulkDelete,
      tableForm: _ctx.formData,
      addButtonText: `${_ctx.t('pages.form.addSection')}`,
      "bulk-delete-text-for-sections": _ctx.bulkDeleteTextForSections,
      viewName: "sections",
      onQueryUpdate: _ctx.queryUpdate,
      onTableRowClick: _ctx.tableRowClick,
      onFormSubmit: _ctx.submit,
      onSelectedItemsForDelete: _ctx.selectedItemsForDelete,
      permissions: _ctx.permissionModel,
      ref: "datatable"
    }, {
      "cell-name": _withCtx(({ row: form }) => [
        _createElementVNode("span", _hoisted_1, _toDisplayString(form.name), 1)
      ]),
      "cell-startDate": _withCtx(({ row: form }) => [
        (form.startDate)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.format.convertUTCToLocalDate(form.startDate)), 1))
          : _createCommentVNode("", true)
      ]),
      "cell-endDate": _withCtx(({ row: form }) => [
        (form.endDate)
          ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.format.convertUTCToLocalDate(form.endDate)), 1))
          : _createCommentVNode("", true)
      ]),
      "cell-status": _withCtx(({ row: form }) => [
        (form.status)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(["text-truncate fw-bolder", {
          'badge badge-success': form.status?.toLowerCase() === 'active',
          'badge badge-danger': form.status?.toLowerCase() !== 'active',
        }])
            }, _toDisplayString(_ctx.format.TitleCase(form.status?.toLowerCase())), 3))
          : _createCommentVNode("", true)
      ]),
      "cell-formDesign": _withCtx(({ row: form }) => [
        (
          _ctx.currentUser.webId === form.userId ||
          (form.lock === false &&
            (_ctx.hasPermission(_ctx.permissionModel.update) ||
              _ctx.hasPermission(_ctx.permissionModel.create)))
        )
          ? (_openBlock(), _createBlock(_component_router_link, {
              key: 0,
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
              to: { name: 'form.builder', params: { id: form.webId } },
              target: "self",
              class: _normalizeClass(["btn btn-icon btn-secondary btn-circle btn-sm ms-2", {
          disabled:
            _ctx.hasPermission(_ctx.permissionModel.read) &&
            !(
              _ctx.hasPermission(_ctx.permissionModel.update) &&
              _ctx.hasPermission(_ctx.permissionModel.create)
            ),
        }])
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 2
            }, 1032, ["to", "class"]))
          : _createCommentVNode("", true),
        (_ctx.currentUser.webId !== form.userId && form.lock)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "btn btn-sm btn-icon btn-active-light-primary ms-2",
              "data-bs-custom-class": "tooltip-dark",
              "data-bs-placement": "top",
              title: "Section Locked",
              onClick: _withModifiers(
          () => {
            _ctx.showDialog = true;
            _ctx.lockedBy = form.userName;
          }
        , ["stop"])
            }, _hoisted_7, 8, _hoisted_5))
          : _createCommentVNode("", true)
      ]),
      "cell-designPreview": _withCtx(({ row: form }) => [
        _createElementVNode("button", {
          class: "btn btn-icon btn-primary btn-circle btn-sm",
          title: 
          form.formSectionInProgressId === null ? 'Desing is not available' : ''
        ,
          disabled: !form.formSectionInProgressId,
          onClick: _withModifiers(($event: any) => (_ctx.openDetailModal(form)), ["stop"])
        }, _hoisted_10, 8, _hoisted_8)
      ]),
      "cell-actions": _withCtx(({ row: form }) => [
        (_ctx.hasPermission(_ctx.permissionModel.update))
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              onClick: _withModifiers(($event: any) => (_ctx.editSection(form)), ["stop"]),
              class: "btn btn-icon btn-primary btn-circle btn-sm"
            }, _hoisted_13, 8, _hoisted_11))
          : _createCommentVNode("", true),
        (_ctx.hasPermission(_ctx.permissionModel.delete))
          ? (_openBlock(), _createElementBlock("a", {
              key: 1,
              onClick: _withModifiers(
          () => {
            _ctx.showDeleteDialog = true;
            _ctx.selectedForAction = form;
          }
        , ["stop"]),
              class: "btn btn-icon btn-danger btn-circle btn-sm ms-3"
            }, _hoisted_16, 8, _hoisted_14))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["table-data", "table-header", "total", "rowsPerPage", "page", "loading", "showSearch", "defaultFilter", "tableFilter", "bulkDelete", "tableForm", "addButtonText", "bulk-delete-text-for-sections", "onQueryUpdate", "onTableRowClick", "onFormSubmit", "onSelectedItemsForDelete", "permissions"]),
    _createVNode(_component_VZSideDrawer, {
      modelValue: _ctx.openDrawer,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.openDrawer) = $event)),
      title: _ctx.sideDrawerTitle,
      icon: _ctx.sideDrawerIcon,
      onClose: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openDrawer = false)),
      tabs: _ctx.tabs
    }, null, 8, ["modelValue", "title", "icon", "tabs"]),
    _createVNode(_component_TemplatePreviewModal, {
      sectionId: _ctx.selectedTemplateId,
      name: _ctx.selectedTemplateName
    }, null, 8, ["sectionId", "name"]),
    (_ctx.hasPermission(_ctx.permissionModel.delete))
      ? (_openBlock(), _createBlock(_component_VZDeleteModal, {
          key: 0,
          viewName: "sections",
          selectedForAction: [_ctx.selectedForAction.webId],
          showDialog: _ctx.showDeleteDialog,
          deleteText: _ctx.deleteAlertMessage(_ctx.selectedForAction),
          pageName: "section",
          onClose: _ctx.refreshList
        }, null, 8, ["selectedForAction", "showDialog", "deleteText", "onClose"]))
      : _createCommentVNode("", true),
    _createVNode(_component_VZModal, {
      id: `vz_modal_section_locked`,
      title: `${_ctx.t('pages.form.lock.title')}`,
      showDialog: _ctx.showDialog,
      onModalClose: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showDialog = false)),
      widthClass: 'width-650'
    }, {
      actions: _withCtx(() => [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showDialog = false))
        }, _toDisplayString(_ctx.t("common.close")), 1)
      ]),
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_17, [
          _createTextVNode(_toDisplayString(_ctx.t("pages.form.lock.msg")) + " ", 1),
          _createElementVNode("strong", null, _toDisplayString(_ctx.lockedBy), 1),
          _createTextVNode(". " + _toDisplayString(_ctx.t("pages.form.lock.msgAdmin")), 1)
        ])
      ]),
      _: 1
    }, 8, ["title", "showDialog"]),
    _createVNode(_component_ActivityModal, {
      refresh: _ctx.loading,
      icon: "bi bi-list-stars fs-3",
      viewName: "Sections Activity Pulse",
      type: "2700,600"
    }, null, 8, ["refresh"])
  ], 64))
}